import React from 'react';
import { I18n } from '@aws-amplify/core';

import type { BeraRevisionType } from '@/types/Bera';
import * as S from './styles';

interface RevisionOptionProps {
	title: string;
	description: string;
	revisionType: BeraRevisionType;
	disabled: boolean;
	onSelect: (revisionType: BeraRevisionType) => void;
}

export function RevisionOption({
	title,
	description,
	revisionType,
	disabled,
	onSelect
}: Readonly<RevisionOptionProps>): JSX.Element {
	function handleClick() {
		onSelect(revisionType);
	}

	return (
		<S.OptionCard type="button" disabled={disabled} onClick={handleClick}>
			<S.OptionTitle>{I18n.get(title)}</S.OptionTitle>
			<S.OptionDescription>{I18n.get(description)}</S.OptionDescription>
		</S.OptionCard>
	);
}
